<template lang="pug">
  UiModal(
    :show="show"
    @close="close"
    :title="$t('companies.approvers.import_title')"
    :subtitle="$t('companies.approvers.import_title')"
    :rightActions="rightActions"
  )
    UiFilePicker(
      v-model="file"
      placeholder="Choose a file or drop it here..."
      :extensions="['xlsx']"
    )
</template>

<script>
import ApiApprovers from "@/api/approvers.js"

export default {
  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      companyId: null,
      show: false,
      file: null,
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.upload"),
          icon: "FileUpload",
          disabled: !this.file,
          onClick: this.upload,
        },
      ];
    },
  },

  methods: {
    open(companyId) {
      this.companyId = companyId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    upload() {
      let formData = new FormData();
      formData.append("file", this.file);
      ApiApprovers.importApprovalSettings(this.companyId, formData)
        .then((resp) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {});
    },
  },
};
</script>